import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { REGEXP_EMAIL } from '@/constants/regex';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { getUtf8ByteLength } from '../utils/string';

export const useRules = () => {
  const { t } = useTranslation();
  const maxNameBytes = 50;
  const validateNameByteLength = (value: string) =>
    getUtf8ByteLength(value ?? '') <= maxNameBytes || t('max_length_validation', { length: maxNameBytes });

  return {
    email: {
      required: t('email_required_validation'),
      pattern: { value: REGEXP_EMAIL, message: t('email_format_error') },
      maxLength: { value: 50, message: t('max_length_validation', { length: 50 }) },
    },

    phone: {
      required: t('phone_required_validation'),
      validate: (phone: string, values: FieldValues) => {
        const phoneWithAreaCode = values?.areaCode + phone;
        return isValidPhoneNumber(phoneWithAreaCode) || t('phone_format_error');
      },
      maxLength: { value: 50, message: t('phone_format_error') },
    },

    firstName: {
      required: t('first_name_required_validation'),
      validate: validateNameByteLength,
    },

    lastName: {
      required: t('last_name_required_validation'),
      validate: validateNameByteLength,
    },

    password: {
      required: t('password_required_validation'),
    },

    authcode: {
      required: t('verification_code_required_validation'),
      minLength: { value: 6, message: t('six_digit_code_validation') },
    },
  };
};
